import { memo } from 'react'
import PropTypes from 'prop-types'
import { useModal, Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'
import ModalContent from './components/ModalContent/ModalContent'

const ShipmentsOptions = ({ shipments, skus, region }) => {
  const { setModal } = useModal()

  const regionName = `${region.city} - ${region.stateCode}`

  const showModal = () => {
    setModal({
      appElement: 'body',
      hasScroll: true,
      children: ({ onClose }) => (
        <ModalContent
          onClose={onClose}
          shipments={shipments}
          skus={skus}
          regionName={regionName}
        />
      )
    })
  }

  return (
    <S.ModalTrigger
      size="kilo"
      decoration="underline"
      noMargin
      onClick={showModal}
    >
      Outras formas de frete para{' '}
      <Text size="kilo" as="strong" bold noMargin>
        {regionName}
      </Text>
    </S.ModalTrigger>
  )
}

ShipmentsOptions.propTypes = {
  shipments: PropTypes.arrayOf(
    PropTypes.shape({
      skuId: PropTypes.string,
      modalities: PropTypes.objectOf(
        PropTypes.shape({
          cost: PropTypes.number.isRequired,
          quotePrice: PropTypes.number.isRequired,
          deadline: PropTypes.number.isRequired
        })
      )
    })
  ).isRequired,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      shop: PropTypes.shape({
        name: PropTypes.string
      })
    })
  ).isRequired,
  region: PropTypes.shape({
    city: PropTypes.string,
    id: PropTypes.string,
    region: PropTypes.string,
    state: PropTypes.string,
    stateCode: PropTypes.string
  }).isRequired
}

export default memo(ShipmentsOptions)
